import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "mx-6" }, null, -1)
const _hoisted_3 = { class: "mt-4 mb-2 px-6 w-full flex items-center justify-between" }
const _hoisted_4 = {
  key: 1,
  class: "pl-4 font-normal text-gray-900 text-sm"
}
const _hoisted_5 = { class: "px-6 pt-2 pb-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_AddClinicXRayEquipment = _resolveComponent("AddClinicXRayEquipment")!
  const _component_ClinicsXRayEquipmentsListHeader = _resolveComponent("ClinicsXRayEquipmentsListHeader")!
  const _component_ClinicsXRayEquipmentsListBody = _resolveComponent("ClinicsXRayEquipmentsListBody")!
  const _component_BaseTableWrapper = _resolveComponent("BaseTableWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_InputField, {
        label: "Otsi seadet",
        value: _ctx.nameSearchInput,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nameSearchInput) = $event)),
        class: "w-64"
      }, null, 8, ["value"]),
      (_ctx.userState.admin)
        ? (_openBlock(), _createBlock(_component_AddClinicXRayEquipment, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, " Seadme lisamiseks, muutmiseks või kustutamiseks palun võtke ühendust meie klienditoega! "))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_BaseTableWrapper, null, {
        default: _withCtx(() => [
          _createVNode(_component_ClinicsXRayEquipmentsListHeader),
          _createVNode(_component_ClinicsXRayEquipmentsListBody, { "name-filter-input": _ctx.nameSearchInput }, null, 8, ["name-filter-input"])
        ]),
        _: 1
      })
    ])
  ]))
}